import { render, staticRenderFns } from "./editDetails.vue?vue&type=template&id=79ddd817&scoped=true"
import script from "./editDetails.vue?vue&type=script&lang=js"
export * from "./editDetails.vue?vue&type=script&lang=js"
import style0 from "./editDetails.vue?vue&type=style&index=0&id=79ddd817&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ddd817",
  null
  
)

export default component.exports